import React from 'react';
import OrderSummery from './OrderSummery';
import OutlinedCard from './OutlinedCard';
import './DeliveryInfo.css';
const DeliveryInfo = ({ windowDimensions, trackData }) => {
    return (
        <div className="container delivery-info-block">
            <div className="row">
                <div className="col-sm-4 track-home">
                    <OutlinedCard trackData={trackData} />
                </div>
                <div className="col-sm-8 track-order-block">
                    <OrderSummery windowDimensions={windowDimensions} trackData={trackData} />
                </div>
            </div>
        </div>
    );
};

export default DeliveryInfo;